<div class="container-fluid mt-10" *ngIf="isCompleted">
  <p *ngIf="varified">
    <strong>{{userName}}</strong> with the email address <strong>{{emailAddress}}</strong>  is verified successfully. 
    The admin can now access and manage the <strong>{{companyName}}</strong>‘s data anytime, anywhere. 
    The admin will be notified by an email.
  </p>
  <p *ngIf="isLinkExpired">
    The verification link is expired.
  </p>
</div>